<template>
	<div class="ccl-selected-list">
		<div class="ccl-selected-list__label">Activated</div>
		<ScrollContainer
			v-if="hasItemsSelected"
			variant="infinity-scroll"
			:hasMoreItems="false"
			:showEndResultByDefault="false"
			:takeFixedHeight="fixedHeight"
		>
			<ul class="selected-clients__list">
				<li v-for="(item, index) in itemsSelectedSorted" :key="index">
					<Divider
						v-if="hasItemsSelected && index !== 0"
						class="selected-clients__divider"
					/>

					<div class="selected-clients__name">
						{{ `${item.customerNumber} (${item.customerName})` }}
					</div>
					<div
						class="selected-clients__all"
						v-if="item.activeBetaFeature"
					>
						All companies / sub locations selected
					</div>
					<ul>
						<li
							v-for="(company, index) in item.companies"
							:key="index"
						>
							<CompanyLocationCard
								:number="company.companyNumber"
								:iconClass="'icon icon-company'"
								v-if="company.activeBetaFeature"
								class="selected-clients__company-locations"
							>
								<template #ellipsis>
									<Ellipsis
										:data="company.companyName"
										class="selected-clients__company-location-name"
									/>
								</template>
							</CompanyLocationCard>

							<ul
								v-if="
									company.locations &&
										company.locations.length > 0
								"
							>
								<li
									v-for="(location,
									index) in company.locations"
									:key="index"
								>
									<CompanyLocationCard
										:number="location.locationNumber"
										:iconClass="'icon icon-location'"
										v-if="location.activeBetaFeature"
										class="selected-clients__company-locations"
									>
										<template #ellipsis>
											<Ellipsis
												:data="location.locationName"
												class="selected-clients__company-location-name"
											/>
										</template>
									</CompanyLocationCard>
								</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</ScrollContainer>
		<p class="ccl-selected-list__no-results" v-else>
			The activated list is empty. Please choose from the client list to
			make a selection
		</p>
	</div>
</template>

<script>
import Divider from '@/components/shells/divider/divider';
import Ellipsis from '@/components/visual/ellipsis';
import CompanyLocationCard from '@/components/ccl-selector/ccl-right-side/company-location-card.vue';
import ScrollContainer from '@/components/shells/scroll-container/scroll-container';
import _ from 'lodash';

export default {
	name: 'CclSelectedList',
	components: {
		Divider,
		Ellipsis,
		CompanyLocationCard,
		ScrollContainer
	},
	props: {
		itemsSelected: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			fixedHeight: { height: 100, unit: '%' }
		};
	},
	computed: {
		hasItemsSelected() {
			return !_.isEmpty(this.itemsSelected);
		},
		itemsSelectedSorted() {
			if (this.hasItemsSelected) {
				return _.orderBy(
					this.itemsSelected,
					[
						item =>
							item.customerName && item.customerName.toLowerCase()
					],
					['asc']
				);
			}
			return [];
		}
	}
};
</script>

<style lang="scss" scoped>
.ccl-selected-list {
	border: 1px solid $neutral-3;
	padding: $padding-md;
	background-color: $white;
	border-radius: $border-radius;
	gap: $gutter-xl;
	display: flex;
	flex-direction: column;

	&__label {
		font-size: $bd-txt-font-size-sm;
		color: $neutral-2;
	}

	&__no-results {
		color: $neutral-2;
		font-size: $bd-txt-font-size-regular;
	}
}

.selected-clients {
	&__divider {
		margin-bottom: $gutter-lg;
	}
	&__name {
		@include heading(md);
	}
	&__list {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
	}

	&__company-locations {
		display: flex;
		flex-direction: column;
		margin-bottom: $gutter-md;
	}

	&__all {
		color: $neutral-2;
		font-size: $bd-txt-font-size-sm;
		margin-bottom: $gutter-lg;
	}
	&__company-location-name {
		font-size: $bd-txt-font-size-regular;
	}
}
</style>
